import PropTypes from 'prop-types';
import React from 'react';

import ResponsiveImage from 'components/ResponsiveImage';

const BackgroundImage = ({ image }) => {
  const landscapeImage = image?.landscape?.src?.includes('.mp4') ? undefined : image?.landscape;
  const portraitImage = image?.portrait?.src?.includes('.mp4') ? undefined : image?.portrait;

  if (!landscapeImage?.src || !portraitImage?.src) {
    return null;
  }

  return (
    <ResponsiveImage
      className="BackgroundImage HeroSlide__background-image order-1"
      mobileSrc={portraitImage.src}
      desktopSrc={landscapeImage.src}
      alt={portraitImage.alt}
      mobileWidth={portraitImage.width}
      mobileHeight={portraitImage.height}
      desktopWidth={landscapeImage.width}
      desktopHeight={landscapeImage.height}
      sizes="(min-width: 1200px) 90vw, 100vw"
      coverParentNode
    />
  );
};

const assetPropType = PropTypes.shape({ src: PropTypes.string.isRequired, alt: PropTypes.string });

BackgroundImage.propTypes = {
  image: PropTypes.shape({
    landscape: assetPropType.isRequired,
    portrait: assetPropType,
  }).isRequired,
};

export default BackgroundImage;
